module.exports = __webpack_public_path__ + "media/nivel2.be59d5a3.png";